/**
 * @generated SignedSource<<db634edc14d2a2b401f0875150fc0c96>>
 * @relayHash 9f60693109ad4f6327b00a4b29bc50c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19f30000a2ebc8a1863d976bb9da3ded183d9259f2cc66c99a645299f2c21917

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorContentUnifiedQuery$variables = {
  contentId: string;
  draftShareId?: string | null;
  status?: ReadonlyArray<string | null> | null;
  versionOverride?: number | null;
};
export type EditorContentUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentTypesHeaderFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"EditorContentTypesHeader_content">;
      };
    } | null> | null;
  } | null;
};
export type EditorContentUnifiedQuery = {
  response: EditorContentUnifiedQuery$data;
  variables: EditorContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "draftShareId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v4 = [
  {
    "kind": "Variable",
    "name": "draftShareId",
    "variableName": "draftShareId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "contentTypeModified"
  },
  {
    "kind": "ScalarField",
    "name": "number"
  },
  {
    "kind": "ScalarField",
    "name": "friendlyWhen"
  },
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "when"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorContentUnifiedQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "EditorContentTypesHeader_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTypesHeaderFragment"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorContentUnifiedQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "operation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetType"
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "alias": "smartFolderProperties",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "smartFolderProperties"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      }
                    ]
                  }
                ],
                "storageKey": "properties(keys:[\"smartFolderProperties\"])"
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9f60693109ad4f6327b00a4b29bc50c1",
    "id": "19f30000a2ebc8a1863d976bb9da3ded183d9259f2cc66c99a645299f2c21917",
    "metadata": {},
    "name": "EditorContentUnifiedQuery",
    "operationKind": "query",
    "text": "query EditorContentUnifiedQuery($contentId:ID!,$versionOverride:Int,$draftShareId:String,$status:[String]){content(id:$contentId,version:$versionOverride,draftShareId:$draftShareId,status:$status){nodes{...EditorContentTypesHeader_content,id}}}fragment EditorContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}"
  }
};
})();

(node as any).hash = "f349f307a478ad1c71eec39f57b91493";

export default node;
